var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"icon"},[_vm._v(_vm._s(_vm.iconLetter))]),_c('div',{staticClass:"info"},[_c('div',[_vm._v(_vm._s(_vm.partnerName))]),_c('div',{staticClass:"contact-person-name"},[_vm._v(_vm._s(_vm.contactPersonName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }